/**
 *
 * Este componente esta basado en:
 *
 * https://material-ui.com/demos/tables/
 */

import * as React from 'react';
import { ComponentClass } from 'react';
import * as _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import { TextField, Theme, WithStyles } from '@material-ui/core';
import classNames from 'classnames';
import { ExcludeClasses, mockTheme } from '../utils/utils';
import { default as StoreModel, LoadedResource } from '../store/StoreModel';
import theme from 'src/utils/theme';
import moment from 'moment';
import { format } from 'date-fns';

/**
 * Estilos del header
 */
const toolbarStyles = (tema: Theme) => ({
    root: {
        paddingRight: tema.spacing.unit,
    },
    highlight:
        tema.palette.type === 'light'
            ? {
                color: tema.palette.secondary.main,
                backgroundColor: lighten(tema.palette.secondary.light, 0.85),
            }
            : {
                color: tema.palette.text.primary,
                backgroundColor: tema.palette.secondary.dark,
            },
    spacer: {
        flex: '1 1 100%',
    },
    actions: {
        color: tema.palette.text.secondary,
    },
    title: {
        flex: '0 0 auto',
    },
});

/**
 * Estos son los estilos principales
 */
const styles = (tema: Theme) => ({
    wrapperDiv: {
        width: '100%'
    },
    root: {
        width: `calc(100% - ${tema.spacing.unit * 2}px)`,
        margin: tema.spacing.unit,
    },
    table: {
        width: `calc(100% - ${tema.spacing.unit * 2}px)`,
        margin: tema.spacing.unit,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
});

export type SortOptions = 'asc' | 'desc';


interface EnhancedTableHeadProps {
    onRequestSort: (e: React.MouseEvent<HTMLElement>, prop: string) => void;
    order: 'asc' | 'desc';
    orderBy: string;
    columns: ColumnDefinition[];
    numSelected: number;
    rowCount: number;
    onSelectAllClick: (e: React.ChangeEvent<HTMLInputElement>, selected: boolean) => void;
    withCheck: boolean;


}

export interface ColumnDefinition {
    path: string;
    numeric?: boolean;
    disablePadding?: boolean;
    label: string;
    draw?: (cd: ColumnDefinition, value: any) => React.ReactNode;
    widht?: string
}


/**
 * Este componente renderiza el HEADER
 */
class EnhancedTableHead extends React.Component<EnhancedTableHeadProps> {

    constructor(props: EnhancedTableHeadProps) {
        super(props);
    }

    createSortHandler(property: string) {
        return (event: React.MouseEvent<HTMLElement>) => {
            this.props.onRequestSort(event, property);
        };
    }


    render() {
        const { order, orderBy, numSelected, rowCount, onSelectAllClick } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {
                        this.props.withCheck &&
                        <TableCell padding="checkbox">
                            <Checkbox
                                indeterminate={numSelected > 0 && numSelected < rowCount}
                                checked={numSelected === rowCount}
                                onChange={onSelectAllClick}
                            />
                        </TableCell>
                    }
                    {this.props.columns.map((column,index) => {
                        return (
                            <TableCell
                                key={index}
                                style={{ width: 50 }}
                                numeric={column.numeric}
                                padding={column.disablePadding === undefined ? 'none' : column.disablePadding ? 'none' : 'default'}
                                sortDirection={orderBy === column.path ? order : false}
                            >
                                {column.path &&
                                    <Tooltip
                                        title={`Ordenar por ${column.label}`}
                                        placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                        enterDelay={300}
                                    >
                                        <TableSortLabel
                                            active={orderBy === column.path}
                                            direction={order}
                                            onClick={this.createSortHandler(column.path)}
                                        >
                                            {column.label}
                                        </TableSortLabel>
                                    </Tooltip>
                                }
                                {!column.path && column.label}
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

const toolbarTypes = toolbarStyles(mockTheme);

interface EnhancedTableToolbarProps extends WithStyles<keyof typeof toolbarTypes> {
    /**
     * Cantidad de elementos seleccionados
     */
    numSelected: number;
    /**
     * Titulo de la tabla
     */
    title: string;

    noSelectionButtons?: React.ReactNode;
}


/**
 * Este componente solo renderiza el toolbar (y el titulo, etc)
 */
class EnhancedTableToolbar extends React.Component<EnhancedTableToolbarProps> {

    constructor(props: EnhancedTableToolbarProps) {
        super(props);
    }

    renderNoSelectionButtons() {
        if (this.props.noSelectionButtons) {
            return this.props.noSelectionButtons;
        } else {
            return (<div />)
        }
    }

    render() {

        const { classes, numSelected, title } = this.props;

        return (
            <Toolbar
                className={classNames(classes.root, {
                    [classes.highlight]: numSelected > 0,
                })}
            >
                <div className={classes.title}>
                    {numSelected > 0 ? (
                        <Typography color="inherit" variant="subheading">
                            {numSelected} seleccionados
                        </Typography>
                    ) : (
                        <Typography variant="title" id="tableTitle">
                            {title}
                        </Typography>
                    )}
                </div>
                <div className={classes.spacer} />
                <div className={classes.actions}>
                    {numSelected > 0 ? (
                        <Tooltip title="Delete">
                            <IconButton aria-label="Delete">
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    ) : this.renderNoSelectionButtons()}
                </div>
            </Toolbar>
        );
    }
}

const EnhancedTableToolbarWS = withStyles(toolbarStyles)(EnhancedTableToolbar);
const classesType = styles(mockTheme);

interface EnhancedTableProps extends WithStyles<keyof typeof classesType> {
    data?: any[] | LoadedResource<any>;
    title: string;
    columnDefinition: ColumnDefinition[];
    defaultOrder?: {
        name?: string,
        direction?: SortOptions
    };
    withCheck?: boolean;

    headerButtons?: React.ReactNode;

    wrapInPaper?: boolean;
    showHeader?: boolean;
    showFiltro?: boolean;
    getSelected?: (clientIds: any) => void;
}

interface EnhancedTableState {
    order: SortOptions;
    orderBy: string;
    selected: any[];
    page: number;
    rowsPerPage: number;
    filtro: string;
    filtroFecha: boolean;
    fechIni?: number;
    fechFin?: number;
}

class EnhancedTable extends React.Component<EnhancedTableProps, EnhancedTableState> {
    constructor(props: EnhancedTableProps) {
        super(props);

        this.state = {
            order: this.props.defaultOrder && this.props.defaultOrder.direction || 'desc',
            orderBy: this.props.defaultOrder && this.props.defaultOrder.name || 'id',
            selected: [],
            page: 0,
            rowsPerPage: 5,
            filtro: "",
            filtroFecha: false
        };

        this.getSorting = this.getSorting.bind(this);
        this.handleRequestSort = this.handleRequestSort.bind(this);
        this.handleSelectAllClick = this.handleSelectAllClick.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.isSelected = this.isSelected.bind(this);
        this.renderRows = this.renderRows.bind(this);
        this.renderCellContent = this.renderCellContent.bind(this);
    }

    handleFiltroChange = (event: any) => {
        this.setState({ filtro: event.target.value });
    };

    isLoaded(props: any): props is LoadedResource<any> {
        if (!props) {
            return false
        } else {
            return props.fetching !== undefined;
        }
    }

    getData(): any[] {
        if (!this.props.data) {
            return []
        }
        if (Array.isArray(this.props.data)) {
            return this.props.data;
        }
        return this.props.data.data;
    }

    getSorting(order: SortOptions, orderBy: string): (a: any, b: any) => number {
        return order === 'desc'
            ? (a, b) => (_.get(b, orderBy) < _.get(a, orderBy) ? -1 : 1)
            : (a, b) => (_.get(a, orderBy) < _.get(b, orderBy) ? -1 : 1);
    }

    handleRequestSort(event: React.MouseEvent<HTMLElement>, property: string) {
        const orderBy = property;
        let order: SortOptions = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>, checked: true) => {
        if (!this.props.data) {
            return;
        }
        if (checked) {
            this.setState({ selected: this.getData().map(n => n.id) });
            return;
        }
        this.setState({ selected: [] });
    };

    handleClick(event: React.MouseEvent<HTMLElement>, id: number) {
        if (!this.props.withCheck) {
            return;
        }

        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected: any[] = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        this.setState({ selected: newSelected });
    }

    handleChangePage(event: React.MouseEvent<HTMLButtonElement> | null, page: number) {
        this.setState({ page });
    }

    // handleChangeRowsPerPage(event: React.MouseEvent<HTMLElement>) {
    handleChangeRowsPerPage(event: any) {
        this.setState({ rowsPerPage: event.target.value });
    }

    isSelected(id: number) {
        return this.state.selected.indexOf(id) !== -1
    }


    renderCellContent(cd: ColumnDefinition, data: any) {
        if (cd.draw) {
            return cd.draw(cd, data);
        }
        return (
            <span>
                {_.get(data, cd.path)}
            </span>
        )
    }

    componentDidUpdate(prevProps: Readonly<EnhancedTableProps>, prevState: Readonly<EnhancedTableState>, snapshot?: any): void {
        const clientes = this.getData();
        // console.log('Basura: ', this.state.selected, prevState.selected);
        if (this.props.getSelected && this.state.selected.length !== 0 && this.state.selected !== prevState.selected) {
            const client = clientes.filter(
                (d: any) => d.id === this.state.selected[0]
            );
            // console.log('cliente obtenido: ', client)
            this.props.getSelected(client);
        }
    }

    // Funcion para buscar el contenido del filtro en un objeto
    buscarFiltro(filtro: string, data: object, path: string, estado: any): any {
        if (data !== null || data !== undefined) {
            for (const i in data) {
                // En caso de que el filtro y la fecha sean tru sale del ciclo
                if (estado.pal === true && estado.fech === true) {
                    break;
                } else if (data[i] !== null) {
                    // Comprobamos primero la fecha
                    if (!estado.fech && this.state.filtroFecha && i.toLowerCase().includes('date')) {
                        let fechaEvaluado = { ini: false, fin: false };

                        // Evaluamos si la fecha esta en el rango y si este rango existe
                        const fechaEval = moment(data[i], 'DD-MM-YYYY');

                        if (this.state.fechIni) {
                            const fechaInicio = moment(this.state.fechIni, 'YYYY-MM-DD');
                            // console.log('fechaInicio',fechaEval, fechaInicio, fechaEval.isSameOrAfter(fechaInicio));   
                            if (fechaEval.isSameOrAfter(fechaInicio)) {
                                fechaEvaluado = { ...fechaEvaluado, ini: true };
                            }
                        } else {
                            fechaEvaluado = { ...fechaEvaluado, ini: true };
                        }
                        if (this.state.fechFin) {
                            const fechaFin = moment(this.state.fechFin, 'YYYY-MM-DD');
                            if (fechaEval.isSameOrBefore(fechaFin)) {
                                fechaEvaluado = { ...fechaEvaluado, fin: true };
                            }
                        } else {
                            fechaEvaluado = { ...fechaEvaluado, fin: true };
                        }
                        if (fechaEvaluado.ini === true && fechaEvaluado.fin === true) {
                            estado.fech = true;
                        }
                    } else if (this.state.filtroFecha === false && estado.fech === false) {
                        estado.fech = true;
                    }
                    // Analiza si el data es un objeto para volver a auto llamarse
                    if (filtro === "" || filtro === null) {
                        estado.pal = true;
                    } else if (typeof (data[i]) === 'object' && path.toLowerCase().includes(i.toLowerCase())) {
                        // Si el dato a comprobar es un objeto llama de vuelta esta funcion recursiamente
                        estado = this.buscarFiltro(filtro, data[i], path, estado);
                        return estado;
                        // Busca coincidencias en las palabras
                    } else if (path.includes(i) && data[i].toString().toLowerCase().includes(filtro.toLowerCase())) {
                        estado.pal = true;
                    }
                }
            }
        }
        return estado;
    }



    renderRows(order: SortOptions,
        orderBy: string,
        originalData: any[] | undefined | LoadedResource<any>,
        rowsPerPage: number,
        page: number,
        columnDefinition: ColumnDefinition[],
        checkbox: boolean,
        filtro: string) {

        let loading = false;
        let empty = false;
        let data: any[] = [];

        if (!originalData) {
            // console.log('no data');
            loading = true;
            empty = false;
        } else if (this.isLoaded(originalData)) {
            // console.log('loaded');
            loading = StoreModel.isLoading(originalData);
            empty = StoreModel.isEmpty(originalData);
            data = originalData.data;
        } else if (Array.isArray(originalData)) {
            // console.log('array', originalData);
            loading = false;
            empty = !originalData.length;
            data = originalData;
        } else {
            // console.log('some moster', originalData);
        }

        const singleMessage = loading ? 'Cargando ...' :
            empty ? 'No hay datos que mostrar!' :
                null;

        if (singleMessage) {
            // console.log('sm', singleMessage);
            return (
                <TableBody>
                    <TableRow>
                        <TableCell colSpan={columnDefinition.length}>
                            <Typography>
                                {singleMessage}
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableBody>
            )
        }
        // console.log('shoging', originalData, data);

        const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);
        let sorteData: any[] = _.sortBy(data, [(o: any) => {
            return _.get(o, orderBy)
        }]);
        if (order === 'desc') {
            sorteData = sorteData.reverse();
        }

        let filtrado = sorteData;
        if (this.props.showFiltro && filtrado.toString() !== '[]') {
            if (!this.state.filtroFecha) {
                // Habilita el filtro si en el path de la columna existe la palabra 'date'
                columnDefinition.map((col) => {
                    if (col.path.toLowerCase().includes('date')) {
                        this.setState({
                            filtroFecha: true
                        });
                    }
                })
            }
            // Filtramos solo en caso de que este sea requerido y que haya alguna coincidencia
            filtrado = filtrado.filter((s) => {
                // Estado inicial de los resultados
                let encontro = { pal: false, fech: false };
                this.props.columnDefinition.map((col) => {
                    encontro = this.buscarFiltro(this.state.filtro, s, col.path, encontro);
                });
                if (encontro.pal === true && encontro.fech === true) {
                    return true;
                } else {
                    return false;
                }
            });
            
        }

        return (
            <TableBody>
                {filtrado
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((n, i) => {
                       
                        
                        const isSelected = this.isSelected(n.id);
                        return (
                            <TableRow
                                hover
                                onClick={event => this.handleClick(event, n.id)}
                                role="checkbox"
                                aria-checked={isSelected}
                                tabIndex={-1}
                                key={
                                    n.id !== undefined && n.id !== null && n.id !== ''
                                        ? `row-${n.id}`
                                        : `row-fallback-${page * rowsPerPage + i}`
                                }
                                selected={isSelected}
                            >
                                {
                                    checkbox &&
                                    <TableCell padding="checkbox">
                                        <Checkbox checked={isSelected} />
                                    </TableCell>
                                }
                                {columnDefinition.map((cd,idx) => {
                                    return (
                                        <TableCell
                                            key={idx}
                                            scope="row"
                                            component="th"
                                            style={{ width: cd.widht ? cd.widht : `calc(100% - ${theme.spacing.unit * 2}px)` }}
                                            padding={cd.disablePadding === undefined ? 'none' : cd.disablePadding ? 'none' : 'default'}
                                            numeric={cd.numeric === undefined ? false : cd.numeric}>
                                            {this.renderCellContent(cd, n)}
                                        </TableCell>
                                    )
                                })}
                            </TableRow>
                        );
                    })
                }
                {
                    emptyRows > 0 && (
                        <TableRow style={{ height: 49 * emptyRows }}>
                            <TableCell colSpan={columnDefinition.length} />
                        </TableRow>
                    )
                }

            </TableBody>
        )
    }

    render() {

        const { order, orderBy, selected, rowsPerPage, page } = this.state;
        const { classes, data, title, columnDefinition, withCheck, headerButtons } = this.props;
        let { wrapInPaper, showHeader } = this.props;

        const dataSize = this.getData().length;

        if (wrapInPaper === undefined) {
            wrapInPaper = true;
        }
        if (showHeader === undefined) {
            showHeader = true;
        }


        const fullTable = (
            <div className={classes.wrapperDiv}>
                {showHeader &&
                    (
                        <EnhancedTableToolbarWS
                            numSelected={selected.length}
                            title={title}
                            noSelectionButtons={headerButtons}
                        />
                    )}
                {this.props.showFiltro && <div>
                    <TextField
                        type='search'
                        onChange={this.handleFiltroChange}
                        style={{ marginLeft: 15, marginRight: 15 }}
                        label="Filtro"
                    />
                    {this.state.filtroFecha && <>
                        {/* Desde: <TextField
                            type='date'
                            id='desdeDate'
                            name='Desde'
                            style={{ marginRight: 15, marginTop: 10 }}
                            value={this.state.fechIni ? new Date(this.state.fechIni).toISOString().slice(0, 10) : this.state.fechIni}
                            onChange={(event: any) => {
                                if (event.target.value !== "" && event.target.value) {
                                    const fecha = new Date(event.target.value);
                                    fecha.setHours(1, 0, 0);
                                    fecha.setDate(fecha.getDate() + 1);
                                    this.setState({ fechIni: fecha.valueOf() })
                                }
                            }}
                        /> */}
                        Desde: <TextField
                            type='date'
                            id='desdeDate'
                            name='Desde'
                            style={{ marginRight: 15, marginTop: 10 }}
                            value={this.state.fechIni ? this.state.fechIni : format(new Date(), "YYYY-MM-DDTHH:mm")}
                            onChange={(event: any) => {
                                if (event.target.value !== "" && event.target.value) {
                                    this.setState({ fechIni: event.target.value })
                                }
                            }}
                        />
                        Hasta: <TextField
                            type='date'
                            id='hastaDate'
                            name='Hasta'
                            style={{ marginRight: 15, marginTop: 10 }}
                            value={this.state.fechFin ? this.state.fechFin : format(new Date(), "YYYY-MM-DDTHH:mm")}
                            onChange={(event: any) => {
                                if (event.target.value !== "" && event.target.value) {
                                    this.setState({ fechFin: event.target.value })
                                }
                            }}
                        />
                    </>}
                </div>}
                <div className={classes.tableWrapper}>
                    <Table className={classes.table} aria-labelledby="tableTitle">
                        <EnhancedTableHead
                            columns={columnDefinition}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={this.handleRequestSort}
                            numSelected={selected.length}
                            onSelectAllClick={this.handleSelectAllClick}
                            rowCount={dataSize}
                            withCheck={withCheck || false}
                        />
                        {this.renderRows(order, orderBy, data, rowsPerPage, page, columnDefinition, withCheck || false, this.state.filtro)}
                    </Table>
                </div>
                <TablePagination
                    component="div"
                    count={dataSize}
                    rowsPerPage={rowsPerPage}
                    page={page}

                    backIconButtonProps={{
                        'aria-label': 'Atras',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'Siguiente',
                    }}
                    labelRowsPerPage={(<Typography variant="caption">Elementos por página</Typography>)}
                    labelDisplayedRows={(info) => (
                        <Typography variant="caption">{info.from}-{info.to} de {info.count}</Typography>)}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />

            </div>
        );

        if (wrapInPaper) {
            return (
                <Paper className={classes.root}>
                    {fullTable}
                </Paper>
            );
        }
        return fullTable;
    }
}


const styled = withStyles(styles as any)(EnhancedTable);


export default styled as ComponentClass<ExcludeClasses<EnhancedTableProps>>;



// WEBPACK FOOTER //
// ./src/components/AsyncTable.tsx